export const ro = {
    'nav.today': "Sumar Astăzi",
    'nav.calendar': "Calendar Cerere",
    'nav.rates': "Tarife și Reguli",
    'nav.automation': "Automatizare",
    'nav.audit': "Jurnal Audit",
    'nav.settings': "Setări",
    'sidebar.status': "Conectat",
    'stat.occupancy': "Grad de Ocupare",
    'stat.adr': "ADR (Tarif Mediu)",
    'stat.revpar': "RevPAR",
    'stat.revenue': "Venit Est.",
    'stat.trend.vsLastWeek': "vs Săpt. Trecută",
    'stat.trend.onPace': "În grafic",
    'dashboard.actions.title': "Acțiuni Recomandate",
    'dashboard.actions.empty': "Nu s-au găsit acțiuni.",
    'filter.all': "Toate",
    'filter.pricing': "Prețuri",
    'filter.restriction': "Restricții",
    'action.approve': "Aprobă",
    'action.reject': "Respinge",
    'action.risk.low': "risc scăzut",
    'action.risk.medium': "risc mediu",
    'action.risk.high': "risc ridicat",
    'action.label.current': "Curent",
    'action.label.proposed': "Propus",
    'action.metric.impact': "Impact",
    'action.metric.why': "Motiv",
    'action.status.executed': "Auto-Executat",
    'header.search': "Caută...",
    'header.logout': "Deconectare",
    'auto.level.title': "Nivel Pilot Automat",
    'auto.level.manual': "Manual",
    'auto.level.manual.desc': "Aprobi fiecare recomandare.",
    'auto.level.assisted': "Asistat",
    'auto.level.assisted.desc': "Aprobă automat riscul scăzut. Revizuire schimbări majore.",
    'auto.level.auto': "Complet Automat",
    'auto.level.auto.desc': "IA gestionează prețurile 24/7 în limitele tale.",
    'auto.level.active': "Activ",
    'auto.guardrails.title': "Limite de Siguranță",
    'auto.guardrails.maxIncrease': "Creștere Max. Zilnică",
    'auto.guardrails.maxIncrease.desc': "Evită șocuri de preț.",
    'auto.guardrails.maxDecrease': "Scădere Max. Zilnică",
    'auto.guardrails.maxDecrease.desc': "Evită dumping accidental.",
    'auto.guardrails.minRate': "Tarif Minim",
    'auto.guardrails.minRate.desc': "Niciodată sub acest preț (Net).",
    'auto.emergency.title': "Control Urgență",
    'auto.emergency.label': "Oprire de Urgență",
    'auto.emergency.desc': "Pauză imediată la toată automatizarea.",
    'auto.emergency.btn': "PAUZĂ SISTEM",
    'rates.filter.all': "Toate Tipurile",
    'rates.filter.next14': "Următoarele 14 Zile",
    'rates.export': "Exportă",
    'audit.table.time': "Ora",
    'audit.table.actor': "Autor",
    'audit.table.category': "Categorie",
    'audit.table.action': "Acțiune",
    'audit.table.details': "Detalii",
    'audit.table.status': "Status",
    'settings.pms.title': "Conexiune PMS",
    'settings.pms.connected': "Conectat la",
    'settings.pms.disconnect': "Deconectează",
    'settings.account.title': "Cont",
    'settings.account.role': "Rol",
    'settings.restart': "Repornește Onboarding",
    'onboard.title': "Conectează PMS",
    'onboard.desc': "Selectează sistemul tău (PMS) pentru sincronizare.",
    'onboard.connecting': "Se conectează...",
    'onboard.connect': "Conectează",
    'onboard.success.title': "Configurare Completă!",
    'onboard.success.desc': "**SynthHotel Berlin** este acum sincronizat.",
    'onboard.success.sub': "Importat 3 tipuri de camere, 14 planuri tarifare și 243 rezervări.",
    'onboard.btn.dashboard': "Mergi la Panou",
    'action.dynamic.weekend.title': "Crește Tarif Weekend",
    'action.dynamic.weekend.desc': "Ocupare > 75% Sâmbătă, cerere mare (+12 camere în 24h).",
    'action.dynamic.minstay.title': "Activează Sejur Min. 2 Nopți",
    'action.dynamic.minstay.desc': "Concert Taylor Swift. Evită sejururi de 1 noapte.",
    'action.dynamic.distress.title': "Scade Tarif (Cerere Mică)",
    'action.dynamic.distress.desc': "Ocupare 35% Marțea viitoare. Competitorii au scăzut cu €10.",
    'action.dynamic.gap.title': "Umple Gol: Scoate CTA",
    'action.dynamic.gap.desc': "Gol o singură noapte. Scoate 'Închis la Sosire' pentru a vinde.",
};
